<template>
  <div>
    <v-progress-linear v-if="loadingProviders > 0" :indeterminate="true" />
    <v-list v-else-if="providers.length > 0" two-line>
      <v-list-tile v-for="provider in providers" :key="provider.id" @click="$emit('selectProvider', provider)">
        <v-list-tile-content>
          <v-list-tile-title :class="`${provider.color}--text`">{{ provider.name }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ $t('editingContainer.dishes', { count: dishesCount(provider)}) }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-card-title v-else>
      <v-icon class="pr-2">visibility_off</v-icon>
      <span v-t="'editingContainer.noProvidersFound'" />
    </v-card-title>
  </div>
</template>

<script>
export default {
  name: 'CopyProviderModalProviders',
  props: {
    loadingProviders: {
      type: Number,
      default: 0,
    },
    providers: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    dishesCount(provider) {
      return provider.categories.map(c => c.selections.length).reduce((acc, val) => acc + val, 0);
    },
  },
};
</script>
